import axios from "axios";

export default class SessionServices {
  constructor() {
    this.API_LINK = process.env.VUE_APP_API_LINK;
  }

  async login(user) {
    try {
      let response = await axios({
        headers: {
          "Content-Type": "application/json"
        },
        method: "post",
        url: `${this.API_LINK}/admin/auth/login`,
        data: user
      });
      return response.data;
    } catch (error) {
      console.log('Session#login error: ', error);
      throw error;
    }
  }
}